import React from 'react';
import { Truck, MapPin, Clock, Package } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const Services = () => {
  const services = [
    {
      icon: Truck,
      title: 'Mumbai to Chakan Specialist',
      description: 'Dedicated routes from Mumbai & Navi Mumbai to Chakan with specialized handling for industrial goods.',
      features: ['Full Load Service', 'Express Delivery', 'GPS Tracking']
    },
    {
      icon: Clock,
      title: 'Daily Service Routes',
      description: 'Regular daily service from Sanpada Godown to Chakan ensuring consistent and reliable transportation.',
      features: ['Daily Departures', 'Fixed Schedule', 'Guaranteed Slots']
    },
    {
      icon: MapPin,
      title: 'Mumbai to Pune & Return',
      description: 'Complete full-load service between Mumbai and Pune with return trips, optimizing your logistics costs.',
      features: ['Round Trip Service', 'Flexible Timing', 'Cost Effective']
    },
    {
      icon: Package,
      title: 'Mumbai to Nashik & Return',
      description: 'Reliable full-load transportation service connecting Mumbai to Nashik with safe and timely deliveries.',
      features: ['Full Load Capacity', 'Secure Transport', 'Real-time Updates']
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our <span className="text-red-600">Services</span>
          </h2>
          <p className="text-lg text-gray-600">
            Comprehensive logistics solutions tailored to meet your transportation needs across Maharashtra.
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="group hover:shadow-xl transition-all duration-300 border-2 hover:border-red-200 cursor-pointer"
              >
                <CardContent className="p-8">
                  <div className="flex items-start space-x-4">
                    <div className="flex-shrink-0">
                      <div className="w-16 h-16 bg-red-100 rounded-xl flex items-center justify-center group-hover:bg-red-600 transition-colors duration-300">
                        <Icon className="w-8 h-8 text-red-600 group-hover:text-white transition-colors duration-300" />
                      </div>
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-red-600 transition-colors">
                        {service.title}
                      </h3>
                      <p className="text-gray-600 mb-4 leading-relaxed">
                        {service.description}
                      </p>
                      <ul className="space-y-2">
                        {service.features.map((feature, idx) => (
                          <li key={idx} className="flex items-center text-sm text-gray-700">
                            <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full mr-2"></div>
                            {feature}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;